/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type InboxThreadResponseLastMessageDirection = typeof InboxThreadResponseLastMessageDirection[keyof typeof InboxThreadResponseLastMessageDirection] | null;


export const InboxThreadResponseLastMessageDirection = {
  inbound: 'inbound',
  outbound: 'outbound',
} as const;
